import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { Betriebskontakt } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt';
import { GruppeTierService } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-kontakt-setzen-dialog',
    templateUrl: './kontakt-setzen-dialog.component.html',
    styleUrls: ['./kontakt-setzen-dialog.component.scss'],
})
export class KontaktSetzenDialogComponent {
    selectedKontakt: Betriebskontakt | null = null;
    isSaving = false;

    constructor(
        private readonly dialogRef: MatDialogRef<KontaktSetzenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { tiere: GruppeTier[] },
        private readonly gruppeTierService: GruppeTierService,
        private readonly messageService: MessageService,
    ) {}

    onKontaktSelected(kontakt: Betriebskontakt): void {
        this.selectedKontakt = kontakt;
    }

    onKontakteSelected(kontakte: Betriebskontakt[]): void {
        if (kontakte?.length > 0) {
            this.onKontaktSelected(kontakte[0]);
        }
    }

    save(): void {
        if (!this.data?.tiere?.length) {
            this.messageService.errorMessage('Keine Tiere ausgewählt!', null);
            return;
        }

        this.isSaving = true;
        this.gruppeTierService
            .updateKontaktMultiple(
                this.data.tiere,
                {
                    updateKontakt: true,
                    kontaktId: this.selectedKontakt?.kunde_id ?? null,
                },
            )
            .subscribe({
                next: success => {
                    this.isSaving = false;
                    if (success) {
                        this.messageService.infoMessage(
                            this.selectedKontakt
                                ? 'Kontakt wurde für alle ausgewählten Tiere gesetzt.'
                                : 'Kontakt wurde für alle ausgewählten Tiere entfernt.',
                        );
                        this.dialogRef.close(true);
                    } else {
                        this.dialogRef.close(false);
                    }
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Kontakt konnte nicht aktualisiert werden!', err);
                },
            });
    }

    cancel(): void {
        this.dialogRef.close(false);
    }
}


